<template>
  <div>
    <b-form-select
      v-model="selected"
      :options="options"
      @change="$emit('input', selected)"
      :disabled="isDisabled"
    ></b-form-select>
  </div>
</template>

<script>
export default {
  props: ['defaultValue', 'isDisabled'],
  data() {
    return {
      selected: 0,
      options: [
        { value: 0, text: this.$i18n.t('Selecione') },
        { value: 1, text: 'Sport Radar (padrão)' },
        { value: 2, text: 'Genius Sports' },
        { value: 4, text: 'SportingSolutions' },
        { value: 5, text: 'Sport Radar (non SR content)' }
      ]
    };
  },
  watch: {
    defaultValue() {
      this.selected = this.defaultValue;
    }
  }
};
</script>

<style lang="scss" scoped></style>
